import React, { useEffect, useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';

import './ImageModal.css';

const ImageModal = ({ isOpen, onClose, imageSrc, altText }) => {
  const [scale, setScale] = useState(1);
  const [imageDimensions, setImageDimensions] = useState({
    width: 'auto',
    height: 'auto',
  });

  useEffect(() => {
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      setImageDimensions({ width: img.width, height: img.height });
    };
  }, [imageSrc]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  const handleWheel = e => {
    e.preventDefault();
    setScale(prevScale =>
      Math.min(Math.max(prevScale + e.deltaY * -0.001, 0.5), 3),
    );
  };

  const handleResetZoom = () => {
    setScale(1);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      // centered
      style={{
        width: '100vw',
        height: '100vh',
        margin: 0,
        overflow: 'hidden', // Disable scrolling in the modal
        backgroundColor: 'transparent',
      }}
      contentClassName="custom-modal-content"
      className="image-modal"
    >
      <button className="close-icon" onClick={onClose} aria-label="Close">
        &times;
      </button>
      <ModalBody
        style={{
          backgroundColor: 'transparent',
          padding: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100vw',
          height: '100vh',
          maxWidth: '100vw',
          maxHeight: '100vh',
          overflow: 'hidden', // Disable scrolling in the modal body
        }}
      >
        <img
          src={imageSrc}
          alt={altText}
          style={{
            maxWidth: '90%',
            maxHeight: '90%',
            cursor: 'pointer',
            transform: `scale(${scale})`,
            transition: 'transform 0.2s',
          }}
          onClick={handleResetZoom}
          onWheel={handleWheel}
        />
      </ModalBody>
    </Modal>
  );
};

export default ImageModal;
